import type { StyleSystemProps } from '@withjoy/joykit';
import { Box, styled } from '@withjoy/joykit';
import type { CSSObject } from '@withjoy/joykit/components/Box/Box.types';

export const StyledGradient = styled(Box)``;
export const StyledBackgroundImage = styled(Box)``;
export const StyledBackgroundVideoContainer = styled(Box)``;
export const StyledBackgroundVideo = styled(Box)``;

const mediaContainerStyles: StyleSystemProps = {
  position: 'absolute',
  top: '0px',
  left: '0px',
  right: '0px',
  zIndex: 'base',
  height: '100%',
};

const mediaLayerStyles: StyleSystemProps = {
  ...mediaContainerStyles,
  height: '100%',
  width: '100%',
};

const gradientStyles = (isCurationsRootPage: Maybe<boolean>, disableBackgroundGradient: boolean): StyleSystemProps => ({
  ...mediaLayerStyles,
  zIndex: 3,
  backgroundImage: !disableBackgroundGradient
    ? isCurationsRootPage
      ? `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.375) 61.63%, rgba(0, 0, 0, 0.5) 100%), linear-gradient(180deg, rgba(0, 0, 0, 0) 3.21%, rgba(0, 0, 0, 0.64) 77.52%, rgba(0, 0, 0, 0.8) 100%)`
      : `linear-gradient(227.91deg,rgba(0,0,0,0) 27.28%,rgba(0,0,0,0.45) 48.96%,rgba(0,0,0,0.6) 73.73%), linear-gradient(180deg, rgba(0, 0, 0, 0) 39.8%, rgba(0, 0, 0, 0.48) 68.69%, rgba(0, 0, 0, 0.6) 100%)`
    : undefined,
});

const backgroundVideoStyles = ($backgroundImageUrl: Maybe<string>): StyleSystemProps => ({
  ...mediaLayerStyles,
  backgroundImage: $backgroundImageUrl ? `url("${$backgroundImageUrl}")` : undefined,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  zIndex: 2,
});

const backgroundImageStyles = ($backgroundImageUrl: Maybe<string>): StyleSystemProps => ({
  ...mediaLayerStyles,
  zIndex: 1,
  backgroundImage: `url("${$backgroundImageUrl || ''}")`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
});

const backgroundVideoContainerStyles: CSSObject = {
  position: 'relative',
  height: '100%',
  overflow: 'hidden',
  padding: '0',
  ['& iframe']: {
    height: '56.25vw',
    left: '50%',
    minHeight: '100%',
    minWidth: '100%',
    transform: 'translate(-50%, -50%)',
    position: 'absolute',
    top: '50%',
    width: '177.77777778vh',
  },
};

export const styles = {
  mediaContainer: mediaContainerStyles,
  gradient: gradientStyles,
  backgroundImage: backgroundImageStyles,
  backgroundVideo: backgroundVideoStyles,
  backgroundVideoContainer: backgroundVideoContainerStyles,
};
